import isEmpty from "lodash/isEmpty";
import { useActivityPermissions } from "PFApp/activities/hooks";
import { AddActivityProfilesModal } from "PFApp/activities/show/parts/activity_profiles/add_activity_profiles_modal";
import { AddProfilesTabs } from "PFApp/activities/show/parts/activity_profiles/constants";
import { BecomeCoownerButton } from "PFApp/components/become_coowner_button/become_coowner_button";
import { useOwners } from "PFApp/hooks/activity_commons/participants";
import { Button } from "PFComponents/button";
import { Flex, Stack } from "PFComponents/containers";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { Activity } from "PFTypes";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { Label } from "../parts/label";

type OwnersProps = {
  activity: Activity;
};

export const Owners = ({ activity }: OwnersProps) => {
  const { t } = useTranslation(["activities", "translation"]);
  const { canBecomeCoOwner } = useActivityPermissions(activity);
  const { owners, canView } = useOwners(activity);

  const [showAddOwners, setShowAddOwners] = useState(false);

  return (
    <Stack>
      <Flex justifyContent="space-between">
        {canView && (
          <div>
            <Label text={t("translation:owner", { count: 1 })} />
            <span>
              {!isEmpty(owners) && (
                <>
                  {owners.map((profile, index) => (
                    <span key={profile.id}>
                      <Link to={`/profiles/${profile.id}`}>
                        <Typography variant="bodyBold" tag="span">
                          {getProfileName(profile)}
                        </Typography>
                      </Link>
                      {index < owners.length - 1 && (
                        <Typography variant="bodyBold" tag="span">
                          ,{" "}
                        </Typography>
                      )}
                    </span>
                  ))}
                </>
              )}
            </span>
          </div>
        )}
        {canBecomeCoOwner && <BecomeCoownerButton activity={activity} small />}
        {activity?.coowned && (
          <Tooltip content={t("activities:show.addProfiles.title_other")}>
            <Button
              icon="owner"
              kind="secondary"
              aria-label={t("activities:show.addProfiles.title_other")}
              onClick={() => setShowAddOwners(true)}
            />
          </Tooltip>
        )}
      </Flex>
      {showAddOwners && (
        <AddActivityProfilesModal
          onClose={() => setShowAddOwners(false)}
          activity={activity}
          tabId={AddProfilesTabs.Owners}
        />
      )}
    </Stack>
  );
};
